/**
 * Created By Jeremy.caoyu at 2019-05-14
 * baseUrl配置函数
 */

import { isIP } from "./util";

const ENV = {
  DEV: 'dev',
  TEST: 'test',
  PRE: 'pre',
  PRO: 'pro'
};

const BASE_URLS = {
  [ENV.DEV]: {
    crm: "service-api.zc.dev.myyixue.com/servicecrm/api/",
    crmApi: "https://test-agent-crm-api.myyixue.com/api/",
    phpUrl: "http://test-schooladmin.myyixue.com/api",
    reportUrl: "https://school-report.myyixue.com/",
    socketUrl: "//test-agent-ws.myyixue.com",
    h5Url: "//h5-school.myyixue.com/",
    monitorUrl: "http://10.173.1.13:9991",
    schoolmUrl: "http://localhost:7777/",
    verifyUrl: "https://test-s.myyixue.com/",
    crmapiv2: "http://crmapiv2.myyixue.com/",
    schoolmApi: "http://service-api.zc.dev.myyixue.com/servicemanageapi/api/",
    // schoolm: "http://192.168.31.227:8090/",
    schoolm: "http://service-api.zc.dev.myyixue.com/servicemanage/",
    erpUrl: "https://test-erp.myyixue.com/ForeignAPI/",
    accountCenter: "//sso.fe.dev.myyixue.com",
  },
  [ENV.TEST]: {
    crm: "https://service-api-test.songshuai.com/servicecrm/api/",
    crmApi: "//test-agent-crm-api.myyixue.com/api/",
    PhpUrl: "//test-schooladmin.myyixue.com/api",
    reportUrl: "//school-report.myyixue.com/",
    socketUrl: "//test-agent-ws.myyixue.com",
    h5Url: "//h5-school.myyixue.com/",
    monitorUrl: "https://qrcode-sto-oss.xstudyedu.com/test/Monitor/index.html",
    schoolmUrl: "https://test-agent-schoolm.myyixue.com/",
    verifyUrl: "https://test-s.myyixue.com/",
    crmapiv2: "https://crmapiv2.myyixue.com/api/",
    schoolmApi: "https://service-api-test.songshuai.com/servicemanageapi/api/",
    schoolm: "https://service-api-test.songshuai.com/servicemanage/",
    erpUrl: "https://test-erp.myyixue.com/ForeignAPI/",
    daraBaseUrl: "//schooldb.myyixue.com",
    accountCenter: "//sso-test.songshuai.com",
  },
  [ENV.PRO]: {
    crm: "//service-api.songshuai.com/servicecrm/api/",
    crmApi: "//agent-crm-api.songshuai.com/api/",
    phpUrl: "//schooladmin.songshuai.com/api",
    reportUrl: "//school-report.songshuai.com/",
    socketUrl: "//agent-ws.songshuai.com",
    h5Url: "//h5-school.songshuai.com/",
    monitorUrl: "https://qrcode-sto-oss.xstudyedu.com/Monitor/index.html",
    schoolmUrl: "https://agent-schoolm.songshuai.com/",
    verifyUrl: "https://s.songshuai.com/",
    crmapiv2: "https://crmapiv2.songshuai.com/",
    schoolmApi: "https://service-api.songshuai.com/servicemanageapi/api/",
    schoolm: "https://service-api.songshuai.com/servicemanage/",
    erpUrl: "https://erp.songshuai.com/ForeignAPI/",
    accountCenter: "//sso.songshuai.com",
  },
  [ENV.PRE]: {
    crm: "https://service-api-pre.songshuai.com/servicecrm/api/",
    crmApi: "//agent-crm-api-pre.songshuai.com/api/",
    phpUrl: "https://schooladmin.songshuai.com/api",
    reportUrl: "https://school-report.songshuai.com/",
    socketUrl: "https://agent-ws-pre.songshuai.com",
    h5Url: "https://h5-school.songshuai.com/",
    monitorUrl: "https://qrcode-sto.songshuai.com/Monitor/index.html",
    schoolmUrl: "https://agent-schoolm-pre.songshuai.com/",
    verifyUrl: "https://s.songshuai.com/",
    crmapiv2: "https://crmapiv2-pre.songshuai.com/",
    schoolmApi: "https://service-api-pre.songshuai.com/servicemanageapi/api/",
    schoolm: "https://service-api-pre.songshuai.com/servicemanage/",
    erpUrl: "https://erp.songshuai.com/ForeignAPI/",
    accountCenter: "https://sso-pre.songshuai.com",
  }
};

/**
 * Determines the current environment based on host
 * @returns {string} Environment name (dev/pre/pro)
 */
const getCurrentEnv = () => {
  const host = window.location.host;
  const hostname = window.location.hostname;

  if (host === "service-pre.songshuai.com") {
    return ENV.PRE;
  }
  if (host === "service-test.songshuai.com") {
    return ENV.TEST;
  }
  if (host.indexOf("localhost") > -1 || 
      host.indexOf("fe.dev.myyixue.com") > -1 || 
      host.indexOf("dev.myyixue.com") > -1 ||
      isIP(hostname)) {
    // return ENV.PRE;
    return ENV.DEV;
  }

  return ENV.PRO;
};

/**
 * Gets all basic URLs for the current environment
 * @returns {UrlConfig} Configuration object with all URLs
 */
export const getBasicUrls = () => {
  const env = getCurrentEnv();
  const urls = BASE_URLS[env];
  const { protocol, hostname } = window.location;

  return {
    ...urls,
    daraBaseUrl: env === ENV.DEV ? `${protocol}//${hostname}:3001` : `//schooldb.${env === ENV.PRO ? 'songshuai.com' : 'myyixue.com'}`,
    env
  };
};

/**
 * Gets the base URL for API calls
 * @returns {string} Base URL
 */
export const getBaseUrl = () => {
  const env = getCurrentEnv();
  
  switch (env) {
    case ENV.DEV:
      return "http://service-api.zc.dev.myyixue.com/servicecrm/api/";
    case ENV.PRE:
      return "https://service-api-pre.songshuai.com/servicecrm/api/";
    case ENV.PRO:
      return "//service-api.songshuai.com/servicecrm/api/";
    default:
      return "https://service-api-test.songshuai.com/servicecrm/api/";
  }
};

/**
 * Gets the PHP API URL
 * @returns {string} PHP API URL
 */
export const getPhpUrl = () => {
  return "https://schooladmin-pre.songshuai.com/api";
};

/**
 * Gets the report URL
 * @returns {string} Report URL
 */
export const reportURL = () => {
  const env = getCurrentEnv();
  const storedIP = localStorage.getItem("IP");

  if (storedIP) {
    return `//${storedIP}/api`;
  }

  return env === ENV.TEST ? "https://school-report.myyixue.com/" :  "//school-report.songshuai.com/";
};

/**
 * Gets the WebSocket URL
 * @returns {string} WebSocket URL
 */
export const getScoketUrl = () => {
  const env = getCurrentEnv();
  const storedIP = localStorage.getItem("IP");

  if (storedIP) {
    return `//${storedIP}/api/`;
  }

  switch (env) {
    case ENV.DEV:
      return "//test-agent-ws.myyixue.com";
    case ENV.PRE:
      return "//agent-ws-pre.songshuai.com";
    case ENV.PRO:
      return "//agent-ws.songshuai.com";
    default:
      return "//test-agent-ws.myyixue.com";
  }
};


export const getAcceptLanguage = () => {
  try {
    const locale = localStorage.getItem('app_locale');
    if (locale === 'zh-CN' || locale === 'en-US') return locale;
  } catch (e) {
    // ignore
  }
  return 'zh-CN';
};
